module.exports = __webpack_public_path__ + "img/rec-17.a1cd585b.png";